import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Oficina } from 'src/app/domain/model/catalogo/oficina';

/**
 * Adaptador HTTP: HttpOficinaRepository
 *
 * Servicio para comunicación HTTP con backend de Oficinas.
 * Endpoints: /api/servicios/oficinas/*
 *
 * @author Emerson Rodriguez - Ingeneo
 */
@Injectable({ providedIn: 'root' })
export class HttpOficinaRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/oficinas`;

  /**
   * Lista todas las oficinas activas
   * Usado en: Programación Masiva - Dropdown de oficinas
   */
  async listarActivas(): Promise<Oficina[]> {
    return firstValueFrom(
      this.http.get<Oficina[]>(this.baseUrl)
    );
  }

  /**
   * Obtiene una oficina por ID
   */
  async obtenerPorId(id: number): Promise<Oficina> {
    return firstValueFrom(
      this.http.get<Oficina>(`${this.baseUrl}/${id}`)
    );
  }

  /**
   * Lista oficinas de una regional
   */
  async listarPorRegional(regionalId: number): Promise<Oficina[]> {
    return firstValueFrom(
      this.http.get<Oficina[]>(`${this.baseUrl}/regional/${regionalId}`)
    );
  }
}
